(function () {
    'use strict';

    var module = angular.module('uwAgenda.tasks');
    // task item component
    module.directive('taskPatient', ['SharedAgendaService', function (SharedAgendaService) {
        var directive = {
            restrict: 'E',
            replace: true,
            scope: {
                patient: '<',
                userId: '<',
                agendaCaption: '@',
                agendaId: '@'
            },
            templateUrl: '/app/tasks/templates/task-patient.template.html'
        };
        return directive;                           
    }]);

})();